/**
 * Answer feedback (thumbs up/down on Standar's answers) tunables. The reason
 * codes mirror the API's `AnswerFeedback::REASONS`; the limit mirrors its
 * `comment` length check.
 */
export const FEEDBACK_REASONS = [
  "inaccurate",
  "did_not_answer",
  "wrong_context",
  "incomplete",
  "hard_to_read",
  "other",
] as const

export type FeedbackReason = (typeof FEEDBACK_REASONS)[number]

/** The reason that requires a free-text comment. */
export const OTHER_REASON: FeedbackReason = "other"

export const MAX_COMMENT_CHARS = 2000

/** Show the character counter once the comment gets this close to the limit. */
export const COMMENT_COUNTER_THRESHOLD_CHARS = 1800

export interface FeedbackDraft {
  reasons: readonly FeedbackReason[]
  comment: string
}

/** A thumbs-down needs a reason, and «Otra» needs text within the limit. */
export function isFeedbackDraftValid({ reasons, comment }: FeedbackDraft): boolean {
  if (reasons.length === 0) return false
  if (comment.length > MAX_COMMENT_CHARS) return false
  if (reasons.includes(OTHER_REASON) && comment.trim().length === 0) return false
  return true
}
